import { QueryClient } from '@tanstack/react-query';

// Single shared instance so authStore/api.ts can clear it on identity
// changes (login, logout, forced re-auth) without importing App.tsx.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30000, // 30 seconds
    },
  },
});
